<div class="support-documentation__video-card-grid">
  <header>
    <h3>Videos</h3>
  </header>
  <div class="grid">
    <sbnb-video-card *ngFor="let video of videos" [video]="video"></sbnb-video-card>
  </div>
</div>
